<template>
  <div class="home">
    <div style="text-align:right;margin-bottom:10px"><Button size="small" @click="$router.go(-1)">返回</Button></div>
    <Row style="line-height:3;max-height:600px;overflow:auto">
      <Col span='24' style="text-align:center;font-size:22px;font-weight:600">{{ details.title }}</Col>
      <Col span='24' v-html="details.content">
      </Col>
      <Col span='24'>{{ details.create_time }}</Col>
    </Row>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        details: {},
      };
    },
    activated() {
      this.$axios
        .get("/app/helpus/index?id=" + this.$route.query.id)
        .then((res) => {
          this.details = res.data;
        });
    },
    methods: {
    },
  };
</script>

<style lang="less" scoped>
  .home {
    width: 96%;
    margin: 0 auto 10px;
    min-height: 50vh;
  }
</style>
